import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import EmojiLoader from './EmojiLoader';

export default function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <EmojiLoader />;

  // Se NÃO está logado, pode ver a rota pública (login, signup, etc.)
  if (!user) return children;

  // Se é admin, manda pro painel
  if (user.role === 'admin') return <Navigate to="/admin" replace />;

  // Se é usuário comum: decide entre onboarding ou dashboard
  const stage = Number.isFinite(Number(user.onboardStage)) ? Number(user.onboardStage) : 0;
  return stage < 4
    ? <Navigate to="/onboarding" replace />
    : <Navigate to="/dashboard" replace />;
}